// employee/reducers.ts
const initialState = {
    getDesignationData: [],
    getDesignationCount: null,
    createDesignationData: null,
    updateDesignationData: null,
    getDesignationMetaMessage: null,
    getDesignationSuccess: false,
    getDesignationFailure: false,
    createDesignationSuccess: false,
    createDesignationFailure: false,
    updateDesignationSuccess: false,
    updateDesignationFailure: false,
    deleteDesignationSuccess: false,
    deleteDesignationFailure: false,
};

export default function DesignationReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_DESIGNATION_SUCCESS': {
            return {
                ...state,
                getDesignationSuccess: true,
                getDesignationData: action.payload?.data?.data?.data,
                getDesignationCount:action.payload?.data?.data?.meta?.total,
                getDesignationFailure: false,
            };
        }
        case 'GET_DESIGNATION_FAILURE': {
            return {
                ...state,
                getDesignationFailure: true,
                getDesignationMetaMessage: action.payload?.data?.data?.meta?.message,
                getDesignationSuccess: false,
            };
        }
        case 'RESET_GET_DESIGNATION': {
            return {
                ...state,
                getDesignationSuccess: false,
                getDesignationFailure: false,
                getDesignationData: [],
                getDesignationMetaMessage: null,
            };
        }

        case 'CREATE_DESIGNATION_SUCCESS': {
            return {
                ...state,
                createDesignationSuccess: true,
                createDesignationData: action.payload?.data?.data?.data,
                getDesignationMetaMessage: action.payload?.data?.data?.meta?.message,
                createDesignationFailure: false,
            };
        }
        case 'CREATE_DESIGNATION_FAILURE': {
            return {
                ...state,
                createDesignationFailure: true,
                getDesignationMetaMessage: action.payload?.data?.data?.meta?.message,
                createDesignationSuccess: false,
            };
        }
        case 'RESET_CREATE_DESIGNATION': {
            return {
                ...state,
                createDesignationSuccess: false,
                createDesignationFailure: false,
                createDesignationData: null,
                getDesignationMetaMessage: null,
            };
        }

        case 'UPDATE_DESIGNATION_SUCCESS': {
            return {
                ...state,
                updateDesignationSuccess: true,
                updateDesignationData: action.payload?.data?.data?.data,
                getDesignationMetaMessage: action.payload?.data?.data?.meta?.message,
                updateDesignationFailure: false,
            };
        }
        case 'UPDATE_DESIGNATION_FAILURE': {
            return {
                ...state,
                updateDesignationFailure: true,
                getDesignationMetaMessage: action.payload?.data?.data?.meta?.message,
                updateDesignationSuccess: false,
            };
        }
        case 'RESET_UPDATE_DESIGNATION': {
            return {
                ...state,
                updateDesignationSuccess: false,
                updateDesignationFailure: false,
                updateDesignationData: null,
                getDesignationMetaMessage: null,
            };
        }

        case 'DELETE_DESIGNATION_SUCCESS': {
            return {
                ...state,
                deleteDesignationSuccess: true,
                getDesignationMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteDesignationFailure: false,
            };
        }
        case 'DELETE_DESIGNATION_FAILURE': {
            return {
                ...state,
                deleteDesignationFailure: true,
                getDesignationMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteDesignationSuccess: false,
            };
        }
        case 'RESET_DELETE_DESIGNATION': {
            return {
                ...state,
                deleteDesignationSuccess: false,
                deleteDesignationFailure: false,
                getDesignationMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
